/* ClickCollectRetailer Vuex State Management
import { stateClickCollectRetailer, gettersClickCollectRetailer, mutationsClickCollectRetailer, actionsClickCollectRetailer} from './clickcollectretailer'
*/
import axios from '@axios';

const stateClickCollectRetailer = {
  ClickCollectRetailers: [],
  ClickCollectRetailersTotal: 0,
  ClickCollectRetailer: {}
}

const gettersClickCollectRetailer = {
};

const mutationsClickCollectRetailer = {
  CLICKCOLLECTRETAILER_LIST_SET(state, value) {
    state.ClickCollectRetailers = value.items;
    state.ClickCollectRetailersTotal = value.total;
  },
  CLICKCOLLECTRETAILER_ITEM_SET(state, value) {
    state.ClickCollectRetailer = value;
  }
};

const actionsClickCollectRetailer = {
    fetchClickCollectRetailers(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .post(`${ctx.rootState.apiUrl}/api/clickcollectretailers`, queryParams)
          .then(response => {
            const { items, total } = response.data;
            ctx.commit('CLICKCOLLECTRETAILER_LIST_SET', {
              items: items,
              total: total
            });
            resolve(response)
          })
          .catch(error => reject(error))
      })
    },
    fetchClickCollectRetailer(ctx, { id }) {
        return new Promise((resolve, reject) => {
            axios
            .get(`${ctx.rootState.apiUrl}/api/clickcollectretailers/${id}`)
            .then(response => {
              ctx.commit('CLICKCOLLECTRETAILER_ITEM_SET', response.data);
              resolve(response)
            })
            .catch(error => reject(error))
        })
    },
    updateClickCollectRetailer(ctx, { id, entity }) {

      ctx.commit('CLICKCOLLECTRETAILER_ITEM_SET', entity);  // update immediately
      return new Promise((resolve, reject) => {
        axios
        .put(`${ctx.rootState.apiUrl}/api/clickcollectretailers/${id}`, entity)
        .then(response => {
          ctx.commit('CLICKCOLLECTRETAILER_ITEM_SET', response.data); // allow for server-side data
          ctx.commit('SNACKBAR_ADD', { color: "secondary", message: " Saved." });
          resolve(response)
        })
        .catch(error => {
          if (error.response && error.response.data) return reject(error.response.data);
          return reject(error);
        })
      })
    },
    createClickCollectRetailer(ctx, { entity }) {

      ctx.commit('CLICKCOLLECTRETAILER_ITEM_SET', entity);  // update immediately
      return new Promise((resolve, reject) => {
        axios
        .post(`${ctx.rootState.apiUrl}/api/clickcollectretailers/create`, entity)
        .then(response => {
          ctx.commit('CLICKCOLLECTRETAILER_ITEM_SET', response.data); // allow for server-side data
          resolve(response)
        })
        .catch(error => {
          if (error.response && error.response.data) return reject(error.response.data);
          return reject(error);
        })
      })
    },
}

export {
  stateClickCollectRetailer,
  gettersClickCollectRetailer,
  mutationsClickCollectRetailer,
  actionsClickCollectRetailer
}